<template>
  <div id="app">
    <keep-alive>
      <transition :name="$route.meta.transition ? 'slide-left' : ''">
        <router-view v-if="$route.meta.keepAlive && $route.meta.transition" />

        <router-view v-if="$route.meta.keepAlive && !$route.meta.transition" />
      </transition>
    </keep-alive>
    <transition :name="$route.meta.transition ? 'slide-left' : ''">
      <router-view v-if="!$route.meta.keepAlive && $route.meta.transition" />
      <router-view v-if="!$route.meta.keepAlive && !$route.meta.transition" />
    </transition>

    <img
      src="@/assets/btnVideoBack.png"
      class="back-tag"
      v-if="$route.meta.back"
      @click="$router.back()"
    />

    <van-popup
      v-model="show"
      :close-on-click-overlay="false"
      class="timeout"
    >
      <img src="@/assets/timeout-bg.png" />
      <img src="@/assets/btnGb50.png" class="btn" @click="resetTimer" />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      onlineTime: +localStorage.getItem('psxly_timeout')||50 * 60 * 1000
    };
  },

  created() {
    if(!localStorage.getItem('psxly_timeout')) {
      localStorage.setItem('psxly_timeout', this.onlineTime)
    }
    this.onlineTimer()
  },

  methods: {
    resetTimer() {
      console.log(this.show);
      // this.$global.timeoutShow = false
      this.onlineTime = 50 * 60 * 1000;
      this.show = false
      this.onlineTimer()
    },
    onlineTimer() {
      let interval = setInterval(() => {
        this.onlineTime -= 1000
        localStorage.setItem('psxly_timeout', this.onlineTime)

        if(this.onlineTime <= 0) {
          this.show = true
          clearInterval(interval)
        }

      }, 1000)
    }
  },
};
</script>

<style lang="scss">
/*-----global CSS 清除浏览默认样式-----*/
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
  box-sizing: border-box;
}
html {
  position: relative;
  height: 100%;
}
body {
  font-family: Microsoft YaHei, SimHei, Arial, Helvetica, sans-serif, SimSun;
  color: #333;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
a:hover {
  text-decoration: none;
}
img {
  border: none;
  vertical-align: bottom;
  display: inline-block;
  display: block;
  border: 0;
}
h1 {
  font-size: 16px;
  font-weight: normal;
}
h2 {
  font-size: 14px;
  font-weight: normal;
}
h3 {
  font-size: 14px;
  font-weight: normal;
}
h4 {
  font-size: 14px;
  font-weight: normal;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.mb30 {
  margin-bottom: 30px;
}
.mr10 {
  margin-right: 10px;
}
.fb {
  font-weight: bold;
}
input::-moz-focus-inner {
  border: none;
  padding: 0;
}
.flex {
  display: flex;
  align-items: center;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  position: absolute;
  width: 100%;
  will-change: transform;
  transition: all 0.2s linear;
  top: 0;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
body {
  font-family: "microsoft yahei,Helvetica";
  max-width: 750px;
  margin: 0 auto;
  color: #333333;
}
.page {
  min-height: 100vh;
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  height: 100%; /*display: none;*/
}
.layer {
  /*display: none;*/
  position: relative; /*overflow: hidden;*/
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.flexC {
  display: flex;
  flex-direction: column;
}
#app {
  position: relative;
}
#home-tag {
  position: fixed;
  right: 0;
  bottom: 20vh;
  width: 200px;
  z-index: 999;
}
.back-tag {
  position: fixed;
  left: 4vw;
  top: 4vw;
  z-index: 999;
  color: #fff;
  width: 8vw;
  height: 8vw;
  text-align: center;
}
.timeout {
  width: 539px;
  background: transparent;
  img {
    width: 100%;
    object-fit: contain;
    &.btn {
      width: 57px;
      height: 57px;
      margin: 57px auto 0;
    }
  }
}
</style>
